import { CheckoutAsyncThunk, portalAction, PortalThunk } from '../types'
import { MPANPaymentSourceCaptureResponse, PaymentSourceCaptureMPANFlowRequest, PaymentSourceCaptureRequest, PaymentSourceCaptureResponse } from '../../model'
import { UpsertOnfileApplePayRequest, UpsertOnfileApplePayResponse } from '@afterpaytouch/portal-api/consumer/checkout/types'

export const captureApplePayPayment: CheckoutAsyncThunk<PaymentSourceCaptureRequest, PaymentSourceCaptureResponse> = portalAction(
  'applepay/token',
  async (request, thunk) => {
    return await thunk.extra.paymentsSourceCapture().post('/source-capture/v1/payment-sources/apple-pay', request)
  },
  false,
  true
)

export const captureApplePayPaymentForMpanFlow: CheckoutAsyncThunk<PaymentSourceCaptureMPANFlowRequest, MPANPaymentSourceCaptureResponse> = portalAction(
  'applepayMpan/token',
  async (request, thunk) => {
    return await thunk.extra.portalApi().post('/portal/consumers/apple-pay-token/capture', request)
  }
)

export const validateMerchant: PortalThunk<ApplePayJS.ApplePayValidateMerchantEvent, { sessionObject: string }> = portalAction(
  'applepay/validateMerchant',
  async (event: ApplePayJS.ApplePayValidateMerchantEvent, thunk) => {
    return await thunk.extra.portalApi().post('/portal/consumers/apple-pay-sessions', { validationUrl: event.validationURL })
  }
)

export const upsertOnfileApplepay: CheckoutAsyncThunk<UpsertOnfileApplePayRequest, UpsertOnfileApplePayResponse> = portalAction(
  'applepay/upsertOnfileApplepay',
  async (request, thunk) => {
    const { token, ...body } = request
    return await thunk.extra.portalApi().post(`/portal/consumers/checkout/v2/${token}/applepay`, body)
  }
)
